import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname.startsWith(path) ? 'nav-link active' : 'nav-link';

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <div className="brand-icon">🫧</div>
        WashWave
      </Link>
      <div className="navbar-links">
        {!user && (
          <>
            <Link to="/shops" className={isActive('/shops')}>Shops</Link>
            <Link to="/login" className="btn btn-primary btn-sm">Login</Link>
          </>
        )}
        {user?.role === 'customer' && (
          <>
            <Link to="/customer/dashboard" className={isActive('/customer/dashboard')}>My Orders</Link>
            <Link to="/customer/new-order" className={isActive('/customer/new-order')}>New Order</Link>
            <Link to="/shops" className={isActive('/shops')}>Shops</Link>
            <button onClick={handleLogout} className="btn btn-ghost btn-sm">Logout</button>
          </>
        )}
        {user?.role === 'laundry_owner' && (
          <>
            <Link to="/owner/requests" className={isActive('/owner/requests')}>Requests</Link>
            <Link to="/owner/orders" className={isActive('/owner/orders')}>My Orders</Link>
            <Link to="/owner/shop" className={isActive('/owner/shop')}>My Shop</Link>
            <button onClick={handleLogout} className="btn btn-ghost btn-sm">Logout</button>
          </>
        )}
      </div>
    </nav>
  );
}
